import React from "react";

import { Stack, useTheme } from "@bps/fluent-ui";
import { Item } from "@components/SelectionList";
import { VerticalTabs } from "@components/VerticalTabs";

interface SoftwarePackageCommandTabsProps {
  commandTabs: Item[];
  selectedTab: string | undefined;
  onSelectedTabChanged: (id: string) => void;
}

export const SoftwarePackageCommandTabs: React.FC<SoftwarePackageCommandTabsProps> = ({
  commandTabs,
  selectedTab,
  onSelectedTabChanged
}) => {
  const theme = useTheme();

  return (
    <Stack
      styles={{
        root: {
          width: 300,
          maxHeight: 700,
          overflowY: "auto",
          borderColor: theme.semanticColors.variantBorder,
          borderWidth: 1,
          borderStyle: "solid",
          padding: theme.spacing.s1
        }
      }}
    >
      <VerticalTabs
        title="Commands"
        tabs={commandTabs}
        selectedTab={selectedTab}
        onSelectedTabChange={onSelectedTabChanged}
      />
    </Stack>
  );
};
